<template>
  <div class="m-auto rounded h-1 w-1/4 bg-grey-light-1" />
</template>
